/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  Fancybox.bind("[data-fancybox]", {
    Hash: false,
    Thumbs: false,
    videoRatio: false,
    Html: {
      vimeoTpl: `<iframe src="{{src}}?byline=0&title=0&portrait=0" 
          allow="autoplay; fullscreen" allowfullscreen></iframe>`
    },
    on: {
      // Hack to remove the byline appearing in fancybox
      "Carousel.createSlide": (fancybox, carousel, slide) => {
        if (slide.type === "vimeo") {
          const url = new URL(slide.src);
          url.searchParams.set("byline", "0");
          url.searchParams.set("title", "0");
          url.searchParams.set("portrait", "0");
          slide.src = url.toString();
        }
      }
    }
  });
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Pageheader Lottie Animation
  ========================================================================== */

const lottieInit = function () {
  const animationWrappers = document.querySelectorAll("[data-lottie]");

  if (!animationWrappers.length) {
    return;
  }

  function getFadeDuration(container) {
    const transitionDurations = window.getComputedStyle(container).transitionDuration.split(",");

    return Math.max(...transitionDurations.map(duration => parseFloat(duration) * (duration.includes("ms") ? 0.001 : 1)));
  }

  function getLastKeyframe(animationData) {
    let lastKeyframe = animationData.ip;

    function inspect(value) {
      if (!value || typeof value !== "object") {
        return;
      }

      if (Array.isArray(value)) {
        const isKeyframeSequence = value.length && value.every(item => item && typeof item === "object" && typeof item.t === "number");

        if (isKeyframeSequence) {
          value.forEach(keyframe => {
            if (keyframe.t >= animationData.ip && keyframe.t <= animationData.op) {
              lastKeyframe = Math.max(lastKeyframe, keyframe.t);
            }
          });
        }

        value.forEach(inspect);
        return;
      }

      Object.values(value).forEach(inspect);
    }

    inspect(animationData);

    return lastKeyframe > animationData.ip ? lastKeyframe : animationData.op;
  }

  animationWrappers.forEach(function (container) {
    // Animation data from PHP
    const animations = JSON.parse(container.dataset.lottie);

    let lottieInstance; // Lottie animation instance
    let currentIndex = 0; // Current animation index

    // Function to play an animation
    function playAnimation(index) {
      // Ensure the container fades out first
      if (container.classList.contains("fade-in")) {
        container.classList.remove("fade-in");
        container.classList.add("fade-out");
      }

      // Wait for fade-out to complete
      setTimeout(() => {
        // Destroy the previous Lottie instance if it exists
        if (lottieInstance) {
          lottieInstance.destroy();
        }

        // Load the new animation
        lottieInstance = lottie.loadAnimation({
          container: container,
          renderer: "svg",
          rendererSettings: {
            preserveAspectRatio: container.dataset.lottieAlign === "top-right" ? "xMaxYMin meet" : "xMidYMid meet"
          },
          loop: false,
          autoplay: false,
          path: animations[index].path
        });

        let hasStartedFadeOut = false;
        let fadeStartFrame;

        lottieInstance.addEventListener("enterFrame", event => {
          if (typeof fadeStartFrame === "undefined") {
            const fadeDurationInFrames = lottieInstance.frameRate * getFadeDuration(container);
            const finalAnimatedFrame = getLastKeyframe(lottieInstance.animationData);

            fadeStartFrame = Math.max(lottieInstance.animationData.ip, finalAnimatedFrame - fadeDurationInFrames);
          }

          if (!hasStartedFadeOut && event.currentTime >= fadeStartFrame) {
            hasStartedFadeOut = true;
            container.classList.remove("fade-in");
            container.classList.add("fade-out");
          }
        });

        // When the animation is ready, fade in and play it
        lottieInstance.addEventListener("DOMLoaded", () => {
          container.classList.remove("fade-out");
          container.classList.add("fade-in");
          lottieInstance.play();
        });

        // When the animation completes, move to the next animation or restart the loop
        lottieInstance.addEventListener("complete", () => {
          setTimeout(() => {
            currentIndex++;

            // If all animations are played
            if (currentIndex >= animations.length) {
              currentIndex = 0;

              setTimeout(() => {
                if (lottieInstance) {
                  lottieInstance.destroy();
                  lottieInstance = null;
                }
                playAnimation(currentIndex); // Restart the loop
              }, 0); // The animation has already faded out before completion
            } else {
              playAnimation(currentIndex); // Play the next animation
            }
          }, 0); // The animation has already faded out before completion
        });
      }, 1000); // Allow the previous animation to clear before loading the next
    }

    // Start the animation loop
    playAnimation(currentIndex);
  });
}; // lottieInit();

lottieInit();

/*  ==========================================================================
    FEATURES & FILTERS - Anchor navigation
    ========================================================================== */

const featuresFiltersAnchorsInit = function () {
  const featuresFiltersModules = document.querySelectorAll("[data-features-filters]");

  if (!featuresFiltersModules.length) {
    return;
  }

  featuresFiltersModules.forEach(function (module) {
    const anchorDropdown = module.querySelector("[data-anchor-dropdown]");
    const anchorToggle = module.querySelector("[data-anchor-toggle]");
    const anchorLabel = module.querySelector("[data-anchor-label]");
    const anchorLinks = module.querySelectorAll(".features-filters__anchor");
    const anchorOptions = module.querySelectorAll("[data-anchor-option]");
    const anchorsContainer = module.querySelector(".features-filters__anchors");
    const sections = Array.from(module.querySelectorAll("[data-features-section]"));
    const initialTargetId = window.location.hash.replace(/^#/, "");
    const hasInitialTarget = sections.some(function (section) {
      return section.id === initialTargetId;
    });
    let activeScrollTargetId = hasInitialTarget ? initialTargetId : false;
    let activeScrollTimer = false;

    const setActiveAnchor = function (targetId) {
      anchorLinks.forEach(function (anchor) {
        const isActive = anchor.getAttribute("href") === "#" + targetId;

        anchor.classList.toggle("features-filters__anchor--active", isActive);

        if (isActive) {
          anchor.setAttribute("aria-current", "location");
        } else {
          anchor.removeAttribute("aria-current");
        }
      });

      anchorOptions.forEach(function (option) {
        const isActive = option.getAttribute("href") === "#" + targetId;

        option.classList.toggle("features-filters__anchor-dropdown-option--active", isActive);

        if (isActive && anchorLabel) {
          anchorLabel.textContent = option.textContent;
        }
      });
    };

    const closeAnchorDropdown = function () {
      if (!anchorDropdown || !anchorToggle) {
        return;
      }

      anchorDropdown.classList.remove("features-filters__anchor-dropdown--active");
      anchorToggle.setAttribute("aria-expanded", "false");
    };

    const scrollToAnchor = function (event, anchor) {
      event.preventDefault();

      const targetId = anchor.getAttribute("href").replace(/^#/, "");
      const target = document.getElementById(targetId);

      if (!target) {
        return;
      }

      activeScrollTargetId = targetId;
      window.clearTimeout(activeScrollTimer);
      setActiveAnchor(targetId);
      closeAnchorDropdown();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.replaceState(null, "", anchor.getAttribute("href"));

      activeScrollTimer = window.setTimeout(function () {
        activeScrollTargetId = false;
      }, 1500);
    };

    anchorLinks.forEach(function (anchor) {
      anchor.addEventListener("click", function (event) {
        scrollToAnchor(event, anchor);
      });
    });

    if (anchorDropdown && anchorToggle) {
      anchorToggle.addEventListener("click", function () {
        const isOpen = anchorDropdown.classList.toggle("features-filters__anchor-dropdown--active");
        anchorToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });

      anchorOptions.forEach(function (option) {
        option.addEventListener("click", function (event) {
          scrollToAnchor(event, option);
        });
      });

      document.addEventListener("click", function (event) {
        if (!anchorDropdown.contains(event.target)) {
          closeAnchorDropdown();
        }
      });

      anchorToggle.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeAnchorDropdown();
        }
      });
    }

    if (!sections.length || !anchorsContainer) {
      return;
    }

    let scrollTicking = false;

    const updateActiveAnchor = function () {
      let activeSection = sections[0];
      const isAtPageBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

      if (activeScrollTargetId) {
        setActiveAnchor(activeScrollTargetId);
        scrollTicking = false;
        return;
      }

      if (isAtPageBottom) {
        activeSection = sections[sections.length - 1];
      } else {
        sections.forEach(function (section) {
          const scrollMarginTop = parseFloat(window.getComputedStyle(section).scrollMarginTop) || 0;
          const scrollPositionTolerance = 4;

          if (section.getBoundingClientRect().top <= scrollMarginTop + scrollPositionTolerance) {
            activeSection = section;
          }
        });
      }

      setActiveAnchor(activeSection.id);
      scrollTicking = false;
    };

    window.addEventListener(
      "scroll",
      function () {
        if (scrollTicking) {
          return;
        }

        window.requestAnimationFrame(updateActiveAnchor);
        scrollTicking = true;
      },
      { passive: true }
    );

    updateActiveAnchor();

    if (activeScrollTargetId) {
      activeScrollTimer = window.setTimeout(function () {
        activeScrollTargetId = false;
      }, 1500);
    }
  });
}; // featuresFiltersAnchorsInit();

featuresFiltersAnchorsInit();

/*  ==========================================================================
    FEATURES & FILTERS - Load more cards
    ========================================================================== */

const featuresFiltersLoadMoreInit = function () {
  const featuresFiltersGrids = document.querySelectorAll("[data-features-grid]");

  if (!featuresFiltersGrids.length) {
    return;
  }

  featuresFiltersGrids.forEach(function (grid) {
    const cards = Array.from(grid.querySelectorAll("[data-feature-card]"));
    const loadMore = grid.querySelector("[data-features-load-more]");
    const smallQuery = window.matchMedia("(min-width: 550px)");
    const largeQuery = window.matchMedia("(min-width: 1000px)");
    const extraLargeQuery = window.matchMedia("(min-width: 1200px)");
    const selectedColumns = parseInt(grid.getAttribute("data-desktop-columns"), 10) || 3;
    let visibleCardCount = 0;

    const getColumnsPerRow = function () {
      if (extraLargeQuery.matches && selectedColumns === 4) {
        return 4;
      }

      if (largeQuery.matches && selectedColumns >= 3) {
        return 3;
      }

      return smallQuery.matches ? 2 : 1;
    };

    const getInitialCardCount = function () {
      return smallQuery.matches ? getColumnsPerRow() * 2 : 3;
    };

    const getCardsPerLoad = function () {
      return smallQuery.matches ? getColumnsPerRow() : 3;
    };

    const updateCards = function () {
      cards.forEach(function (card, index) {
        card.hidden = index >= visibleCardCount;
      });

      if (loadMore) {
        loadMore.hidden = cards.length <= visibleCardCount;
        loadMore.setAttribute("aria-expanded", visibleCardCount > getInitialCardCount() ? "true" : "false");
      }
    };

    const resetCards = function () {
      visibleCardCount = getInitialCardCount();
      updateCards();
    };

    if (loadMore) {
      loadMore.addEventListener("click", function () {
        visibleCardCount += getCardsPerLoad();
        updateCards();
      });
    }

    [smallQuery, largeQuery, extraLargeQuery].forEach(function (mediaQuery) {
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", resetCards);
      } else {
        mediaQuery.addListener(resetCards);
      }
    });

    resetCards();
  });
}; // featuresFiltersLoadMoreInit();

featuresFiltersLoadMoreInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects, window);
        Waypoint.refreshAll();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const totalTilesWidth = Array.from(tiles).reduce((sum, tile) => sum + tile.offsetWidth, 0);
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / totalTilesWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
Accordion
========================================================================== */
const accordionQuestions = document.querySelectorAll(".accordion__item__heading");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }

      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
Featured Tabs
========================================================================== */
window.addEventListener("load", function () {
  // store tabs variable
  var theTabs = document.querySelectorAll(".featured-tabs > .row > .col > .featured-tabs__item");

  function theTabClicks(tabClickEvent) {
    tabClickEvent.preventDefault();

    var clickedTab = tabClickEvent.currentTarget;
    var tabParent =
      tabClickEvent.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
        .parentElement;
    var theTabs = tabParent.querySelectorAll(".featured-tabs > .row > .col > .featured-tabs__item");
    for (var i = 0; i < theTabs.length; i++) {
      theTabs[i].classList.remove("active");
    }

    clickedTab.classList.add("active");
    tabClickEvent.preventDefault();
    var contentPanes = tabParent.querySelectorAll(".featured-tabs__content");
    for (i = 0; i < contentPanes.length; i++) {
      contentPanes[i].classList.remove("active");
    }
    var anchorReference = tabClickEvent.target;
    var activePaneId = anchorReference.getAttribute("href");
    var activePane = tabParent.querySelector(activePaneId);
    activePane.classList.add("active");

    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
  }
  let i;
  for (i = 0; i < theTabs.length; i++) {
    theTabs[i].addEventListener("click", theTabClicks);
  }
});

/*  ==========================================================================
Mobile Tabs for Featured Tabs
========================================================================== */
const mobileTabHeadings = document.querySelectorAll(".featured-tabs__tabs-drodpown__heading");
const mobileTabLinks = document.querySelectorAll(".featured-tabs__tabs-drodpown__menu > .featured-tabs__item");

const mobileTabInit = function (mobileTabHeadings) {
  if (!mobileTabHeadings) {
    return;
  }

  mobileTabHeadings.forEach(item =>
    item.addEventListener("click", function () {
      this.parentElement.classList.toggle("active");
    })
  );

  mobileTabLinks.forEach(item =>
    item.addEventListener("click", function () {
      this.parentElement.parentElement.classList.toggle("active");
      this.parentElement.previousElementSibling.firstElementChild.innerHTML = this.innerHTML;
    })
  );

  function theTabClicks(tabClickEvent) {
    tabClickEvent.preventDefault();

    var clickedTab = tabClickEvent.currentTarget;
    var tabParent =
      tabClickEvent.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
        .parentElement;
    var theTabs = tabParent.querySelectorAll(
      ".featured-tabs > .row > .col > .featured-tabs__tabs-drodpown > .featured-tabs__tabs-drodpown__menu > .featured-tabs__item"
    );
    for (var i = 0; i < theTabs.length; i++) {
      theTabs[i].classList.remove("active");
    }

    clickedTab.classList.add("active");
    tabClickEvent.preventDefault();
    var contentPanes = tabParent.querySelectorAll(".featured-tabs__content");
    for (i = 0; i < contentPanes.length; i++) {
      contentPanes[i].classList.remove("active");
    }
    var anchorReference = tabClickEvent.target;
    var activePaneId = anchorReference.getAttribute("href");
    var activePane = tabParent.querySelector(activePaneId);
    activePane.classList.add("active");

    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
  }
  let i;
  for (i = 0; i < mobileTabLinks.length; i++) {
    mobileTabLinks[i].addEventListener("click", theTabClicks);
  }
}; // mobileTabInit();
mobileTabInit(mobileTabHeadings);

/*  ==========================================================================
    Pinned Scroll List
    ========================================================================== */

const pinnedLists = document.querySelectorAll(".pinned-scrolllist__listitem");
const stickyImages = document.querySelector(".pinned-scrolllist__pinnedimages");

const isWide = () => window.innerWidth > 1000;

const pinnedListsInit = function (pinnedLists) {
  if (!pinnedLists || !isWide() || !stickyImages) {
    return;
  }

  let stickyTop = 0;
  if (stickyImages) {
    stickyTop = parseInt(getComputedStyle(stickyImages).top);
  }

  let isStuck = false;

  // Sentinel to detect when sticky sticks
  const sentinel = document.createElement("div");
  stickyImages.parentNode.insertBefore(sentinel, stickyImages);

  new IntersectionObserver(
    ([entry]) => {
      isStuck = !entry.isIntersecting;
    },
    {
      rootMargin: `-${stickyTop}px 0px 0px 0px`
    }
  ).observe(sentinel);

  const items = document.querySelectorAll(".item");

  // window.addEventListener(
  //   "scroll",
  //   () => {
  //     const centerY = window.innerHeight / 2;

  //     pinnedLists.forEach(item => {
  //       const rect = item.getBoundingClientRect();
  //       const itemCenterY = rect.top + rect.height / 2;
  //       const distance = Math.abs(centerY - itemCenterY);
  //       const maxDistance = window.innerHeight / 2;
  //       const opacity = Math.max(0.2, 1 - distance / maxDistance);

  //       item.style.opacity = opacity;
  //       item.style.filter = `blur(${(1 - opacity) * 4}px)`;
  //     });

  //     if (!isStuck) {
  //       // skip fading the first element
  //       pinnedLists[0].style.opacity = "";
  //       pinnedLists[0].style.filter = "";
  //     }
  //   },
  //   { passive: true }
  // );

  window.addEventListener(
    "scroll",
    () => {
      const centerY = window.innerHeight / 2;
      const holdZone = 0.5; // 0 = no hold, higher = longer fully visible

      pinnedLists.forEach(item => {
        const rect = item.getBoundingClientRect();
        const itemCenterY = rect.top + rect.height / 2;
        const distance = Math.abs(centerY - itemCenterY);
        const maxDistance = window.innerHeight / 2;

        const adjustedDistance = Math.max(0, distance - maxDistance * holdZone);
        const adjustedMax = maxDistance * (1 - holdZone);
        const opacity = Math.max(0.2, 1 - adjustedDistance / adjustedMax);

        item.style.opacity = opacity;
        item.style.filter = `blur(${(1 - opacity) * 4}px)`;
      });

      if (!isStuck) {
        pinnedLists[0].style.opacity = "";
        pinnedLists[0].style.filter = "";
      }
    },
    { passive: true }
  );

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const activeimg = entry.target.dataset.swap;
          const activemodule = entry.target.closest(".pinned-scrolllist");
          if (activeimg) {
            activemodule.querySelectorAll(".pinnedimages__media").forEach(function (item) {
              item.classList.remove("active");
            });
            document.querySelector("." + activeimg).classList.add("active");
          }
        }
      });
    },
    {
      rootMargin: "-50% 0px -50% 0px", // only the middle line of the viewport triggers
      threshold: 0
    }
  );

  pinnedLists.forEach(item => observer.observe(item));
}; // pinnedListsInit();
pinnedListsInit(pinnedLists);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    setTimeout(function () {
      $(elem).owlCarousel({
        autoplay: autoplay,
        autoplayTimeout: autoplayTimeout,
        loop: loop,
        nav: nav,
        dots: dots,
        items: 1,
        navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
        responsive: responsiveArray,
        startPosition: slides.length,
        autoHeight: autoHeight,
        onInitialized: function () {
          lazyLoadInstance.update();
          Waypoint.refreshAll();
        }
      });
    }, 50);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
      // siteheaderWrap.classList.remove("color-white");
    } else {
      // IT'S OPEN...
      navopen = false;
      sitenav__close();

      body.classList.remove(mobnavOpenclass);
    }
  });

  window.addEventListener("resize", function () {
    const isSmallScreen = window.matchMedia("(max-width: 1200px)").matches;
    if (body.classList.contains(mobnavOpenclass) && !isSmallScreen) {
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();

      const mobnavTargetSection = e.target.closest(".sitenav__item");

      if (!mobnavTargetSection.classList.contains(overclass)) {
        navopen = false;
        dropdownsection__open(mobnavTargetSection);
      } else {
        sitenav__close();
      }
    });
  });

  const gobackbtn = document.querySelectorAll(".dropdown__goback");
  gobackbtn.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      let mobnavTargetSection = e.target.closest(".dropdownsection");
      if (mobnavTargetSection) {
        mobnavTargetSection = e.target.closest(".dropdownsection").dataset.section;

        const currentMobSection = document.querySelector(
          ".mobnav .sitenav__item[data-dropdownsection='" + mobnavTargetSection + "']"
        );
        currentMobSection.classList.remove("sitenav__item--open");
      }
      navopen = false;
      sitenav__close();
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Sitheader Scroll Animation
	========================================================================== */

const siteHeader = document.querySelector(".siteheader");

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    siteHeader.classList.add("active");
  } else {
    siteHeader.classList.remove("active");
  }
}

window.onscroll = function () {
  scrollFunction();
};

window.onload = function () {
  scrollFunction();
};

/*  ==========================================================================
    NAVIGATION - sitenav dropdowns
    ========================================================================== */

const sitenav = document.querySelector(".sitenav--left");
const sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");
const sitenavdropdownsections = document.querySelectorAll(".dropdownsection");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;
let currentTopLevelItem = false;
let nextTabItem = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  const isSmallScreen = window.matchMedia("(max-width: 1200px)").matches;

  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("click", function (e) {
        e.preventDefault();

        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
  } else {
    // IF DESKTOP...
    sitenavitems.forEach((sitenavitem, index) => {
      sitenavitem.addEventListener("mouseover", e => {
        if (!isSmallScreen) {
          sitenavitem__over(sitenavitem);
        }
      });
      sitenavitem.addEventListener("mouseout", e => {
        if (!isSmallScreen) {
          sitenav__out();
        }
      });
    });

    sitenavdropdown.addEventListener("mouseover", e => {
      if (!isSmallScreen) {
        dropdownsection__over();
      }
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      if (!isSmallScreen) {
        sitenav__out();
      }
    });
  }

  window.addEventListener("resize", function () {
    sitenav__out();
  });
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  const isSmallScreen = window.matchMedia("(max-width: 1200px)").matches;
  // On hover of sitenav item
  if (!isSmallScreen) {
    dropdownsection__open(sitenavitem);
  }
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);

  if (target_section) {
    var dropdown_height = target_section.offsetHeight;

    // Make dropdown show and set classes to say it's open
    sitenavdropdown.style.visibility = "visible";
    sitenavdropdown.style.height = dropdown_height + "px";
    navopen = true;
    if (dropdownclosetimer) {
      // Clear timeout to stop dropdown closing
      window.clearTimeout(dropdownclosetimer);
    }
    // Remove over class from any old clicks
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    // add over class to current li
    target_li.classList.add(overclass);
    document.querySelector("body").classList.add(navopenbodyclass);
    // siteheaderWrap.classList.remove("color-white");

    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }
    target_section.classList.add(activesectionclass);
  }
} //dropdownsection__open();

function dropdownsection__over() {
  const isSmallScreen = window.matchMedia("(max-width: 1200px)").matches;

  if (isSmallScreen) {
    return;
  }
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 450);
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the

  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }

    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.style.height = 0;
    // sitenavdropdown.style.visibility = "hidden";
  }
} // sitenav__close

/*  ==========================================================================
    GENERAL - Filters Dropdown
  ========================================================================== */

const filtersInit = function () {
  const filtersToggle = document.querySelector(".filters__toggle");
  const filtersDropdown = document.querySelector(".filters__dropdown");

  if (!filtersToggle) {
    return;
  }

  filtersToggle.addEventListener("click", function (e) {
    filtersToggle.classList.toggle("active");
    filtersDropdown.classList.toggle("active");
    Waypoint.refreshAll();
  });
}; //filtersInit();
filtersInit();

/*  ==========================================================================
			FILTERS - Posts Filtering
			========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle");
const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;
/* jshint ignore:start */
if (typeof filters !== "undefined" && filters !== null) {
  // Get current from filters data

  const filterGetFormData = function () {
    let filter_data = {};

    filter_settings.filters.forEach(function (el) {
      let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
      filter_data[el.name] = [...checkedOptions].map(x => x.value);
    });

    return filter_data;
  };

  const filterUpdateURL = function (filterData) {
    let url_params = "";

    for (const [key, value] of Object.entries(filterData)) {
      if (value.length > 0) {
        if (url_params === "") {
          url_params = url_params + "?";
        } else {
          url_params = url_params + "&";
        }
        // Convert values to comma seperated string
        let values = Object.keys(value)
          .map(function (k) {
            return value[k];
          })
          .join(",");

        if (values !== "") {
          url_params = url_params + "filter_" + key + "=" + values;
        } else {
          url_params = "";
        }
      }
    }

    let currentPageUrl = window.location.href.split("?")[0];
    currentPageUrl = currentPageUrl.split("page")[0];

    let newUrl = currentPageUrl + url_params;

    if (url_params !== "") {
      history.pushState({}, "", newUrl);
    }

    if (history.pushState) {
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  };

  // Toggles All Content checkbox if there is selected filters within the group
  const filterSelectedAllCheckboxes = function (groupName) {
    let noActiveFiltersInGroup = true;

    document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
      if (el.checked === true) {
        noActiveFiltersInGroup = false;
      }
    });
    const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
    if (allGroupCheckbox) {
      allGroupCheckbox.checked = noActiveFiltersInGroup;
    }
  };

  // Setup up the active tags in the filter bar
  const filterAddingActiveTags = function (filterData) {
    let hasClassActive = false;
    // Reset styles
    const fieldsets = document.querySelectorAll(".filters__fieldset");
    fieldsets.forEach(set => {
      set.classList.remove("filters__fieldset--active");
    });

    const fieldsetField = document.querySelectorAll(".filters__fieldset__field--categories");
    fieldsetField.forEach(field => {
      field.classList.remove("filters__fieldset__field--active");
    });

    const fieldsetFieldTypes = document.querySelectorAll(".filters__fieldset__field--type");
    fieldsetFieldTypes.forEach(field => {
      field.classList.remove("filters__fieldset__field--active");
    });

    for (const [key, values] of Object.entries(filterData)) {
      if (values.length > 0) {
        // Make field group active
        document
          .querySelector(".filters__fieldset[data-value='" + key + "']")
          .classList.remove("filters__fieldset--active");

        for (const value of values) {
          // Make input field active

          let filter_input = document
            .querySelector("input[name='" + key + "'][value='" + value + "']")
            .closest(".filters__fieldset__field");

          filter_input.classList.add("filters__fieldset__field--active");

          hasClassActive = true;
        }
      }

      filterSelectedAllCheckboxes(key);
    }

    return hasClassActive;
  };

  const filterGetPosts = function (updateURL = false) {
    // Getting the forma data
    let filterData = filterGetFormData();

    if (filterData) {
      // Update url
      if (updateURL) {
        filterUpdateURL(filterData);
      }

      let activeTagsNotEmpty = filterAddingActiveTags(filterData);

      if ((filtersInitialLoad && activeTagsNotEmpty) || !filtersInitialLoad) {
        filtersInitialLoad = false;

        // get site padder header height
        let siteheaderpadder = document.querySelector(".pageheader");
        let siteheaderpadderHeight = siteheaderpadder.offsetHeight;

        // get teams filter height
        let portFilter = document.querySelector(".filters");
        let portFilterHeight = portFilter.offsetHeight;

        let filterPin = document.querySelector(".filters__pin");

        const filterPinRec = filterPin.getBoundingClientRect();

        const top = window.scrollY + filterPinRec.top - portFilterHeight;

        window.scrollTo({
          top: top,
          behavior: "smooth"
        });

        // If there's an active search, open the search field

        // Start filtering
        document.querySelector(".posts.loadmore-container").classList.add("filtering");

        let page_url = window.location.href;
        const typeId = document.querySelector(".fieldset-categories");
        console.log(typeId.dataset.type);

        // Trigger ajax
        let data = {
          action: "filter",
          query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
          page: php_variables.current_page,
          filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
          filter_data: filterData,
          page_url: page_url,
          type: typeId.dataset.type
        };

        $.ajax({
          url: php_variables.ajax_url,
          data: data, // form data
          dataType: "json", // this data type allows us to receive objects from the server
          type: "POST",
          success: function (data) {
            // when filter applied:
            // set the current page to 1
            php_variables.current_page = 1;

            // set the new query parameters
            php_variables.posts = data.posts;

            // set the new max page parameter
            php_variables.max_page = data.max_page;

            // hide load more button, if there are not enough posts for the second page

            const paginationContainer = document.querySelector(".pagination__numbers");
            if (paginationContainer) {
              paginationContainer.innerHTML = data.navigation;
            }

            // insert the posts to the container
            const loadmoreContainer = document.querySelector(".posts.loadmore-container");
            if (loadmoreContainer) {
              loadmoreContainer.innerHTML = data.content;
              // Finish filtering
              loadmoreContainer.classList.remove("filtering");
            }

            setFilterTagsListeners();

            lazyLoadInstance.update();

            const effects = document.querySelectorAll(".effect");

            effectsInit(effects, window);
          },
          error: function (data) {}
        });
      }
    }
  };

  const setFilterTagsListeners = function () {
    const allFilterTags = document.querySelectorAll(".filters__tag");
    allFilterTags.forEach(tag => {
      tag.addEventListener("click", function () {
        let filter_name = tag.dataset.name;
        let filter_value = tag.dataset.value;
        let filter_input = (document.querySelector(
          "input[name='" + filter_name + "'][value='" + filter_value + "']"
        ).checked = false);
        // Remove tag
        tag.remove();
        // Trigger filter
        filterGetPosts();
      });
    });
  };

  const filterSetupClearAll = function () {
    const filterClearAll = document.querySelectorAll(".filters__clearall");
    const filterClearCategories = document.querySelector(".filters__fieldset__field--all");

    const filterClearAllTypes = document.querySelectorAll(".filters__fieldset__field--clear");

    filterClearAll.forEach(btn => {
      btn.addEventListener("click", function () {
        // Uncheck all inputs
        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field--categories input");
        filterCheckboxes.forEach(el => (el.checked = false));

        // Trigger filter
        filterGetPosts(true);

        filterClearCategories.classList.add("filters__fieldset__field--active");
      });
    });

    filterClearAllTypes.forEach(btn => {
      btn.addEventListener("click", function () {
        // Uncheck all inputs
        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field--type input");
        filterCheckboxes.forEach(el => (el.checked = false));

        // Trigger filter
        filterGetPosts(true);

        btn.classList.add("filters__fieldset__field--active");
      });
    });
  };

  // Init Filter on posts pages
  const filterInit = function () {
    let currentPageUrl = window.location.href.split("?")[0];

    const submitBtn = document.querySelector(".filters__apply");
    const filterForm = document.querySelector(".filters__form");

    if (filterForm && filterForm.length) {
      // Get Posts based on Filter Form Data
      filterGetPosts(false);

      // Dropdown open & close
      filtersToggle.addEventListener("click", function (e) {
        e.stopPropagation();
        filters.classList.remove("filters--searchopen");
        filters.classList.toggle("filters--dropdownopen");
      });

      // Filter on submit
      filterForm.addEventListener("submit", function (e) {
        // Stop the form from submitting
        e.preventDefault();

        // Call the filtering post function
        filterGetPosts(true);
        filters.classList.remove("filters--searchopen");
        filters.classList.remove("filters--dropdownopen");
      });

      const filterCheckboxesCategories = filterForm.querySelectorAll(".filters__fieldset__field--categories input");
      const filterToggle = document.querySelector(".filters__toggle");

      const filterCheckboxesCategoriesChecked = document.querySelectorAll(
        ".filters__fieldset__field--categories input:checked"
      );

      if (filterCheckboxesCategoriesChecked.length === 0) {
        // there are no checked checkboxes
        filterToggle.classList.remove("filters__toggle--open");
      } else {
        // there are some checked checkboxes
        filterToggle.classList.add("filters__toggle--open");
      }

      filterCheckboxesCategories.forEach(checkbox => {
        checkbox.addEventListener("change", function () {
          // Submit for on checkbox click
          php_variables.current_page = 1;
          filterGetPosts(true);
          filters.classList.toggle("filters--dropdownopen");
          filterToggle.classList.add("filters__toggle--open");

          const checkedCount = document.querySelectorAll(".filters__fieldset__field input:checked").length;
          if (checkedCount === 0) {
            // there are no checked checkboxes
            filterToggle.classList.remove("filters__toggle--open");
          } else {
            // there are some checked checkboxes
            filterToggle.classList.add("filters__toggle--open");
          }
        });
      });

      // Remove tags on click
      setFilterTagsListeners();

      // Clear all
      filterSetupClearAll();
    }
  };
  filterInit();
}
